import { recommendationFeedback } from './recommendationFeedback';

export const preferences = {
  recommendationFeedback,
};
